import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/site";

export default function CategoryExplorer() {
  const [params, setParams] = useSearchParams();
  const active = params.get("cat") ?? "all";

  const filtered = useMemo(() => {
    if (active === "all") return articles;
    return articles.filter((item) => item.categorySlug === active);
  }, [active]);

  useEffect(() => {
    if (params.get("cat") && window.location.hash === "#latest") {
      const timer = window.setTimeout(() => {
        document.getElementById("latest")?.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [params]);

  const tabs = [{ slug: "all", name: "全部爆料" }, ...categories.map((item) => ({ slug: item.slug, name: item.name }))];

  return (
    <section id="latest" className="mx-auto max-w-content scroll-mt-24 px-4 pt-14 md:px-6 md:pt-20">
      <SectionHeading
        kicker="LATEST"
        title="最新爆料"
        desc="按主题分类查看近期整理与持续跟踪的内容，每一条都附有可核查的线索方向。"
      />

      <div className="no-scrollbar -mx-4 mb-6 flex gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:flex-wrap md:px-0">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => {
              if (tab.slug === "all") {
                setParams({}, { replace: true });
              } else {
                setParams({ cat: tab.slug }, { replace: true });
              }
            }}
            className={`flex-none cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
              active === tab.slug
                ? "bg-foreground-950 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
          <p className="font-heading text-base text-foreground-800">这个分类下的内容还在整理中</p>
          <p className="mt-2 text-sm text-foreground-600">换一个分类看看，或订阅我们的每周深扒推送。</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((item) => (
            <div key={item.id} className="rise-in">
              <ArticleCard article={item} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}